var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "column-layout clearfix" }, [
      _c(
        "div",
        { staticClass: "left-column fl", class: { active: !_vm.treeCollapse } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "tree-menu" } },
            [
              _c("swb-org-tree", {
                attrs: { enableSearch: true, bizDepart: true },
                on: {
                  "notity-change": function($event) {
                    _vm.notityChange($event)
                  },
                  "show-tree-collapse": function($event) {
                    _vm.showTreeCollapse($event)
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right-column fl" }, [
        _c(
          "div",
          {
            staticClass: "content-caption dashed",
            staticStyle: { margin: "5px 0" }
          },
          [
            _c("span", { staticClass: "color-laber" }, [
              _vm._v(_vm._s(_vm.comInfo.name))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "switch-list clearfix ml15" },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.comRole,
                  callback: function($$v) {
                    _vm.comRole = $$v
                  },
                  expression: "comRole"
                }
              },
              _vm._l(_vm.comRoleList, function(comRole) {
                return _c(
                  "div",
                  {
                    staticClass: "switch-item ellipsis-1",
                    staticStyle: { width: "auto", "margin-right": "30px" }
                  },
                  [
                    _c(
                      "el-radio",
                      { attrs: { label: comRole } },
                      [
                        _c("span", [_vm._v(_vm._s(comRole.name))]),
                        _vm._v(" "),
                        comRole.mobAppRoleCode != null
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "success",
                                  "close-transition": ""
                                }
                              },
                              [_vm._v(_vm._s(comRole.mobAppRoleName))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _c("li", { staticClass: "head-item current" }, [_vm._v("组织机构")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14d7ca2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d7ca2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/staffBiz/ServicerRoleForSelect.vue
// module id = 3314
// module chunks = 1